window._pagesLoaded = [];
const _infiniteScrollData = document.querySelector('.infinite-scroll__data');
const _infiniteScrollTotalPages = _infiniteScrollData
  ? _infiniteScrollData.querySelector('input[data-total-pages]')
  : null;
if (_infiniteScrollTotalPages) {
  const _numPages = parseInt(
    _infiniteScrollData.querySelector('input[data-total-pages]').value
  );
  if (_numPages > 1) {
    window._pagesLoaded[0] = true;
    for (let i = 1; i <= _numPages; i++) {
      window._pagesLoaded[i] = false;
    }
  }
}

const resetInfiniteScroll = () => {
  window._pagesLoaded = [];
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

window.resetInfiniteScroll = resetInfiniteScroll;

const sortBy = document.querySelector("select[name='sort_by']");
if (sortBy) {
  sortBy.addEventListener('change', () => {
    window.resetInfiniteScroll();
  });
}

if (window.flags.kso_pagination) {
  // State & Caches
  let isLoading = false;
  const pageCache = window._serverPageCache || (window._serverPageCache = {});
  const pageOffsets =
    window._serverPageOffsets || (window._serverPageOffsets = {});

  // Utilities
  function getInputValue(selector, fallback = '') {
    const el = document.querySelector(selector);
    return el ? el.value ?? fallback : fallback;
  }

  function toInt(v, def = 0) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : def;
  }

  function getPageSize() {
    const gridContainer = document.getElementById('product-grid');
    return toInt(gridContainer?.dataset.pageSize, 12);
  }

  function urlForPage(baseUrl, page) {
    if (!baseUrl) return '';
    if (/([?&])page=\d+/.test(baseUrl)) {
      return baseUrl.replace(/([?&])page=\d+/, `$1page=${page}`);
    }
    return (
      baseUrl + (baseUrl.includes('?') ? `&page=${page}` : `?page=${page}`)
    );
  }

  function parseHTML(htmlString) {
    return new DOMParser().parseFromString(htmlString, 'text/html');
  }

  // Extract valid (non-sold-out) product cards from HTML string.
  function extractValidCardsFromResponse(htmlString) {
    const doc = parseHTML(htmlString);
    const root = doc.querySelector('.load-more-grid') || doc;
    const cards = Array.from(root.querySelectorAll('.collection-product-card'));
    return cards.filter((card) => !card.querySelector('.badge--soldout'));
  }

  // Fetch and cache a server page by page number; returns raw HTML string.
  async function getServerPageHTML(baseUrl, pageNumber) {
    if (pageCache[pageNumber]) return pageCache[pageNumber];

    const url = urlForPage(baseUrl, pageNumber);
    const resp = await fetch(url, { credentials: 'same-origin' });
    if (!resp.ok) throw new Error(`Fetch failed for page ${pageNumber}`);
    const html = await resp.text();
    pageCache[pageNumber] = html; // cache whole page html for later slices
    return html;
  }

  // Count how many valid (non-sold-out) cards exist within a page.
  async function countAtLeastVisibleNonSoldOut(
    startPage,
    endPage,
    baseUrl,
    minNeeded
  ) {
    let found = 0;
    for (let p = startPage; p <= endPage && found < minNeeded; p++) {
      const html = await getServerPageHTML(baseUrl, p);
      const cards = extractValidCardsFromResponse(html);
      const used = pageOffsets[p] || 0;
      const remaining = Math.max(0, cards.length - used);
      found += remaining;
    }
    return Math.min(found, minNeeded);
  }

  // Pull up to `need` valid cards, walking forward from `pointerPage`
  async function takeCardsForward(baseUrl, totalPages, pointerPage, need) {
    const taken = [];
    let fullyConsumedThrough = Math.max(0, pointerPage - 1);

    while (taken.length < need && pointerPage <= totalPages) {
      const html = await getServerPageHTML(baseUrl, pointerPage);
      const validCards = extractValidCardsFromResponse(html);

      const used = pageOffsets[pointerPage] || 0;
      const remaining = Math.max(0, validCards.length - used);
      if (remaining === 0) {
        // This server page is fully consumed; advance the pointer.
        delete pageOffsets[pointerPage];
        fullyConsumedThrough = Math.max(fullyConsumedThrough, pointerPage);
        pointerPage += 1;
        continue;
      }

      const takeNow = Math.min(need - taken.length, remaining);
      if (takeNow > 0) {
        const slice = validCards.slice(used, used + takeNow);
        taken.push(...slice);
        pageOffsets[pointerPage] = used + takeNow;
      }

      // If after taking we consumed the page entirely, advance pointer; else stay.
      if ((pageOffsets[pointerPage] || 0) >= validCards.length) {
        delete pageOffsets[pointerPage];
        fullyConsumedThrough = Math.max(fullyConsumedThrough, pointerPage);
        pointerPage += 1;
      } else {
        break;
      }
    }

    return {
      cards: taken,
      fullyConsumedThrough,
      nextPointerPage: pointerPage,
    };
  }

  // Ensure the first visible page (screen) is filled with `pageSize` valid items.
  // If initial server response had sold-out items, we opportunistically backfill from subsequent pages.
  let isInitialBackfillRunning = false;
  async function ensureFirstPageFilled() {
    if (isInitialBackfillRunning) return;
    isInitialBackfillRunning = true;

    try {
      const totalPages = toInt(getInputValue('[data-total-pages]'), 1);
      const currentPage = toInt(getInputValue('[data-current-page]'), 1);
      const baseNextUrl = getInputValue('[data-next-url]', '');

      const grid = document.querySelector('.load-more-grid');
      if (!grid || !baseNextUrl || totalPages < 1) return;

      const pageSize = getPageSize();
      const visibleNow = Array
        .from(grid.querySelectorAll('.collection-product-card'))
        .filter((el) => !el.querySelector('.badge--soldout')).length;
      let need = Math.max(0, pageSize - visibleNow);

      if (need <= 0 || currentPage >= totalPages) return;

      // Only fetch as many as we can reasonably expect to find.
      const canFind = await countAtLeastVisibleNonSoldOut(
        currentPage + 1,
        totalPages,
        baseNextUrl,
        need
      );
      if (canFind <= 0) {
        const hasPendingPartials = Object.keys(pageOffsets).some(
          (k) => (pageOffsets[k] || 0) > 0
        );
        if (!hasPendingPartials) return;
      }
      need = canFind;

      // Pull cards starting from the pointer page (currentPage + 1 by default)
      const pointerMatch = (getInputValue('[data-next-url]') || '').match(
        /page=(\d+)/
      );
      const pointerStart = pointerMatch
        ? toInt(pointerMatch[1], currentPage + 1)
        : currentPage + 1;

      const { cards, fullyConsumedThrough, nextPointerPage } =
        await takeCardsForward(baseNextUrl, totalPages, pointerStart, need);

      if (cards.length) {
        const frag = document.createDocumentFragment();
        cards.forEach((el) => frag.appendChild(el));
        grid.appendChild(frag);
        if (typeof colorSwatches === 'function') colorSwatches();
      }

      // Update hidden inputs/pointers coherently
      const nextUrlAfter = urlForPage(baseNextUrl, nextPointerPage);
      const currentPageAfter = Math.max(currentPage, fullyConsumedThrough);

      const dataCurrentPage = document.querySelector('[data-current-page]');
      const dataNextUrl = document.querySelector('[data-next-url]');
      if (dataCurrentPage) {
        dataCurrentPage.value = String(currentPageAfter);
        dataCurrentPage.setAttribute('value', String(currentPageAfter));
      }
      if (dataNextUrl) {
        dataNextUrl.value = String(nextUrlAfter);
        dataNextUrl.setAttribute('value', String(nextUrlAfter));
      }

      // If we've consumed everything, remove triggers
      if (nextPointerPage > totalPages) {
        document
          .querySelectorAll('.js-infinite-scroll, .js-load-more')
          .forEach((el) => el.remove());
      }
    } catch (err) {
      console.error('[ensureFirstPageFilled]', err);
    } finally {
      isInitialBackfillRunning = false;
    }
  }

  // Load more items on "load more" button or infinite scroller
  async function loadItems(target) {
    if (isLoading) return;
    isLoading = true;

    const totalPages = toInt(getInputValue('[data-total-pages]'), 1);
    const currentPage = toInt(getInputValue('[data-current-page]'), 1);
    const baseNextUrl = getInputValue('[data-next-url]', '');
    const pageSize = getPageSize();

    try {
      if (!baseNextUrl || currentPage >= totalPages) return;

      target?.setAttribute('disabled', '');
      target?.classList.add('loading');

      const pointerMatch = baseNextUrl.match(/page=(\d+)/);
      const pointerStart = pointerMatch
        ? toInt(pointerMatch[1], currentPage + 1)
        : currentPage + 1;

      const { cards, fullyConsumedThrough, nextPointerPage } =
        await takeCardsForward(baseNextUrl, totalPages, pointerStart, pageSize);

      if (cards.length) {
        const frag = document.createDocumentFragment();
        cards.forEach((el) => frag.appendChild(el));
        (document.querySelector('.load-more-grid') || document).appendChild(
          frag
        );
        if (typeof colorSwatches === 'function') colorSwatches();
      }

      // Update pointers
      const dataCurrentPage = document.querySelector('[data-current-page]');
      const dataNextUrl = document.querySelector('[data-next-url]');

      // currentPage should reflect the highest fully/partially consumed page
      const newCurrent = Math.max(currentPage, fullyConsumedThrough);
      if (dataCurrentPage) {
        dataCurrentPage.value = String(newCurrent);
        dataCurrentPage.setAttribute('value', String(newCurrent));
      }

      if (dataNextUrl) {
        const nextUrl = urlForPage(baseNextUrl, nextPointerPage);
        dataNextUrl.value = String(nextUrl);
        dataNextUrl.setAttribute('value', String(nextUrl));
      }

      // Disable/remove triggers
      if (nextPointerPage > totalPages) {
        document.querySelectorAll('[data-next-url]').forEach((el) => {
          el.value = '';
          el.setAttribute('value', '');
        });
        target?.remove();
      }
    } catch (e) {
      console.error('[loadItems]', e);
    } finally {
      target?.removeAttribute('disabled');
      target?.classList.remove('loading');
      isLoading = false;
    }
  }

  // Observers
  let io;
  function setupInfiniteObserver() {
    const targets = document.querySelectorAll('.js-infinite-scroll');
    if (!targets.length) return;

    if (io) io.disconnect();
    io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) loadItems(entry.target);
        });
      }
    );
    targets.forEach((t) => io.observe(t));
  }

  function loadMore() {
    document.querySelectorAll('.js-load-more').forEach((btn) => {
      btn.onclick = () => loadItems(btn);
    });
    setupInfiniteObserver();
  }

  function cleanCacheAndLoadMore() {
    if (window._serverPageCache) {
      for (const k in window._serverPageCache) delete window._serverPageCache[k];
    }
    if (window._serverPageOffsets) {
      for (const k in window._serverPageOffsets) delete window._serverPageOffsets[k];
    }
    if (Array.isArray(window._pagesLoaded)) window._pagesLoaded.length = 0;
    document.querySelectorAll('.js-infinite-scroll, .js-load-more').forEach(el => {
      el.removeAttribute('disabled');
      el.classList.remove('loading');
    });
    const activeFilters = document.querySelectorAll('.active-facets .active-facets__button').length;

    if (activeFilters > 0) {
      ensureFirstPageFilled();
    }
    loadMore();
  };

  document.addEventListener('DOMContentLoaded', async () => {
    const activeFilters = document.querySelectorAll('.active-facets .active-facets__button').length;
    if (activeFilters > 0) {
      await ensureFirstPageFilled();
    }
    loadMore();
  });
} else {
  function loadItems(target) {
    const totalPages = parseInt($('[data-total-pages]').val());
    let currentPage = parseInt($('[data-current-page]').val());

    const nextPage = currentPage + 1;
    const nextUrl = $('[data-next-url]')
      .val()
      .replace(/page=[0-9]+/, 'page=' + nextPage);
    const updatedNextUrl = $('[data-next-url]')
      .val()
      .replace(/page=[0-9]+/, 'page=' + nextPage);

    if (_pagesLoaded[currentPage]) return;
    _pagesLoaded[currentPage] = true;

    $('[data-current-page]').val(currentPage);
    target.setAttribute('disabled', '');
    target.classList.add('loading');

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (response) {
        $('.load-more-grid').append($(response).find('.load-more-grid').html());
        colorSwatches();
        currentPage += 1;
      },
      error: function (error) {
        _pagesLoaded[currentPage] = false;
      },
      complete: function () {
        if (currentPage <= totalPages) {
          const infiniteScrollData = document.querySelector(
            '.infinite-scroll__data'
          );

          if (infiniteScrollData && currentPage != totalPages) {
            infiniteScrollData.querySelector(
              'input[data-next-url]'
            ).dataset.nextUrl = updatedNextUrl;
            infiniteScrollData.querySelector('input[data-next-url]').value =
              updatedNextUrl;
            infiniteScrollData.querySelector(
              'input[data-current-page]'
            ).dataset.currentPage = currentPage;
            infiniteScrollData.querySelector('input[data-current-page]').value =
              currentPage;
          }

          target.removeAttribute('disabled');
          target.classList.remove('loading');

          if (currentPage == totalPages) {
            target.remove();
          }
        }
      },
    });
  }

  function checkVisibility() {
    document.querySelectorAll('.js-infinite-scroll').forEach((target) => {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(target);
          }
        });
      }).observe(target);
    });
  }

  function loadMore() {
    document.querySelectorAll('.js-load-more').forEach((button) => {
      button.onclick = () => {
        loadItems(button);
      };
    });
    checkVisibility();
  }

  loadMore();
}
